import { makeStyles, Theme } from '@material-ui/core';

export const useHistoryDetailsDialogStyles = makeStyles<Theme>((theme) => ({
  wrapper: {
    width: '100%',
    display: 'grid',
    margin: '0 -8px 0 0',
    [theme.breakpoints.down('xs')]: {
      // display: 'flex',
      // position: 'fixed',
      // left: '0',
      // right: '0',
      // bottom: '0',
      // background: '#292A2F',
      // width: '100%',
      // height: 'auto',
      // flexDirection: 'column',
      // borderRadius: '12px 12px 0 0',
      // padding: '16px 16px 24px 16px',
      // zIndex: 2,
    },
  },
  detailsWrapper: {
    padding: '24px 4px 8px 0',
    display: 'flex',
    flexDirection: 'column',
    gap: 24,
    position: 'relative',
    overflowY: 'scroll',
    overflowX: 'hidden',
    height: 'auto',
  },
  itemWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  itemTitle: {
    color: 'rgba(171, 171, 171, 1)',
    fontSize: 14,
  },
  itemContent: {
    color: 'rgba(250, 250, 250, 1)',
    fontSize: 14,
    fontWeight: 400,
  },
  confirmations: {
    background: 'rgba(253, 172, 93, 0.1)',
    borderRadius: 4,
    color: '#FDAC5D',
    fontWeight: 400,
    fontSize: '12px',
    lineHeight: '20px',
    padding: theme.spacing(1, 2),
    display: 'flex',
    alignItems: 'center',
    '& > svg': {
      margin: '0 0 0 4px',
      marginRight: '0px !important',
      width: '12px',
      height: '12px',
    },
  },
  confirmationComplete: {
    background: '#71DD5F1A',
    color: '#71DD5F',
  },
  confirmationRejected: {
    background: '#FF62621A',
    color: '#E44E45',
  },
  link: {
    cursor: 'pointer',
  },
}));
